import React from 'react';
import { Route, Switch } from 'react-router-dom';
import paths from '../../../../../paths';
import Survey from './Survey';
import SignUpFlow from './SignUpFlow';

const ContentRouter = () => {
  return (
    <Switch>
      {/* Routes */}
      <Route path={paths.welcomeSurvey} component={Survey} />
      <Route component={SignUpFlow} />
    </Switch>
  );
};

export default ContentRouter;
